import { Button, ButtonMode, Modal, ModalWidth, ToasterMode } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { useEffect, useState } from 'react';
import { COPY_WATCHLIST_ERROR, COPY_WATCHLIST_SUCCESS } from '../../../../Base.constants';
import { useGlobalModalContext } from '../../../../components/GlobalModal';
import { useToast } from '../../../../hooks/toast/useToast';
import { useCreateWatchList } from '../../../../hooks/watchLists';
import { NotificationMode, RiskProductAlert } from '../../../../models/Preference';
import styles from './CopyWatchlistModal.module.scss';

const cx = classNames.bind(styles);

interface CopyWatchlistModalProps {
  name: string;
  tags: string[];
}
const CopyWatchlistModal = ({ name, tags }: CopyWatchlistModalProps): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();
  const { showToast } = useToast();
  const [newName, setNewName] = useState(name);
  const { mutate: createWatchlist, isLoading: isCreatingWatchlist } = useCreateWatchList();

  useEffect(() => {
    setNewName(`${name} (copy)`);
  }, [name]);

  const copyWatchlist = () => {
    if (newName && newName.trim()) {
      createWatchlist(
        {
          name: newName,
          myCS: false,
          tags,
          mode: NotificationMode.None,
          riskProductAlert: RiskProductAlert.None,
        },
        {
          onSuccess: () => {
            closeModal();
            showToast(COPY_WATCHLIST_SUCCESS);
          },
          onError: () => {
            showToast(COPY_WATCHLIST_ERROR, ToasterMode.ERROR);
          },
        }
      );
    } else {
      showToast('Watchlist name is required', ToasterMode.ERROR);
    }
  };

  const renderFooter = () => {
    return (
      <>
        <Button mode={ButtonMode.SECONDARY} disabled={isCreatingWatchlist} onClick={closeModal}>
          Cancel
        </Button>
        <Button mode={ButtonMode.PRIMARY} loading={isCreatingWatchlist} onClick={copyWatchlist}>
          Duplicate Watchlist
        </Button>
      </>
    );
  };

  return (
    <Modal
      width={ModalWidth.Medium}
      open
      footer={renderFooter()}
      onClose={closeModal}
      headerTitle="Duplicate Watchlist"
    >
      <input
        type="text"
        className={cx('input')}
        placeholder="Enter Watchlist Name"
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
      />
    </Modal>
  );
};

export default CopyWatchlistModal;
